export default import.meta.ROLLDOWN_FILE_URL_fQyoR3m0eA3DLqol7kyoXA